PegasusTemplate.HostController = Ember.Controller.extend({
  needs: ['header', 'socialFollow', 'application', 'editing'],

  didError: function(attrs){
    var error='',
      serverError = 'is too long (maximum is 100 characters)';

    this.setProperties({
      'controllers.header.content.errors': attrs
    });

    if (attrs.name){
      if(attrs.name[0] === serverError){
        error = attrs.hasOwnProperty('name') ? 'name' : '';
      }
    }
    if (attrs.subject){
      if(attrs.subject[0] === serverError){
        error = attrs.hasOwnProperty('subject') ? error+'subject' : error;
      }
    }
    if (error){
      PegasusTemplate.get('externalProxy').send('showNotification', "error",
        Em.I18n.t('activerecord.errors.models.email.attributes.general.long.'+ error));
    }
    PegasusTemplate.stateMachine.send( 'error' );
  },

  hasErrors: function(){
    return this.get('hasHeaderErrors');
  }.property('hasHeaderErrors'),

  hasHeaderErrors: function(){
    return this.get('controllers.header.hasErrors') || this.get('controllers.header.hasHeaderErrors');
  }.property('controllers.header.hasErrors', 'controllers.header.hasHeaderErrors'),

  didSave: function(){
    PegasusTemplate.stateMachine.send( 'success' );
  },

  showMessage: function(id){
    Ember.run( function(){
      PegasusTemplate.lookupRouter().send('saveAndPreview', Em.Object.create({
        id: id
      }));
    });
  }
});
